/* PDP abaixo da dobra: perspectivas, Mala (cards reais + sacola), avaliações, "Escolher meu tamanho". Dono: C2.
   Idempotente; delegação no document (sem listener duplicado no editor). */
(function () {
  if (window.__svBelowInit) return;
  window.__svBelowInit = true;
  var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* ---- perspectivas: troca a foto principal ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.sv-persp__thumbs button');
    if (!b) return;
    var box = b.closest('[data-sv-persp]'), img = box.querySelector('.sv-persp__main');
    box.querySelectorAll('.sv-persp__thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    if (!img) return;
    img.removeAttribute('srcset'); img.style.opacity = '0.35';
    var n = new Image(); n.onload = function () { img.src = b.dataset.src; img.srcset = b.dataset.srcset; img.alt = b.dataset.alt; img.style.opacity = ''; };
    n.src = b.dataset.src;
  });

  /* ---- perspectivas + âncora do styling seguem a cor escolhida no topo (grupos por cor no Liquid; cor sem grupo esconde o bloco) ---- */
  function syncColor() {
    var r = document.querySelector('input[data-sv-role="color"]:checked');
    if (!r) return;
    var c = r.value.trim().toLowerCase();
    document.querySelectorAll('[data-sv-persp-sec]').forEach(function (sec) {
      var on = null;
      sec.querySelectorAll('.sv-persp__thumbs[data-color]').forEach(function (g) { var m = g.dataset.color === c; g.hidden = !m; if (m) on = g; });
      sec.hidden = !on;
      document.querySelectorAll('a[data-sv-persp-link][href="#' + sec.id + '"]').forEach(function (a) { a.hidden = !on; });
      if (on) { var f = on.querySelector('button'); if (f && f.getAttribute('aria-pressed') !== 'true') f.click(); else if (f) { var img = sec.querySelector('.sv-persp__main'); if (img && img.getAttribute('src') !== f.dataset.src) f.click(); } }
    });
    document.querySelectorAll('.sv-cur__anchor').forEach(function (box) {
      var ph = box.querySelectorAll('.sv-cur__ph[data-color]'); if (!ph.length) return;
      var hit = Array.prototype.some.call(ph, function (p) { return p.dataset.color === c; });
      if (!hit) return; /* sem foto dessa cor: mantém a atual (nunca mostra outra cor por troca) */
      ph.forEach(function (p) { p.hidden = p.dataset.color !== c; });
    });
  }
  document.addEventListener('sv:pdp:variant', syncColor);
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input[data-sv-role="color"]')) setTimeout(syncColor, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncColor); else syncColor();

  /* ---- Escolher meu tamanho ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sv-choose-size]');
    if (!b) return;
    document.dispatchEvent(new CustomEvent('sv:pdp:choose-size'));
    var t = document.querySelector('variant-picker, [data-sv-sizes], .sv-pdp__sizes, .product-information');
    if (!t) return;
    t.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' });
    var f = t.querySelector('input[type="radio"]:checked, input[type="radio"], select, button');
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (x) {} }, reduce() ? 0 : 450);
  });

  /* ---- Mala: "Uma mala, outras possibilidades" ----
     Fonte: sv-pdp-below-cross (editorial: combina_com / sv_look; fallback: Recommendations API related|complementary).
     Aba sem card some; sem abas, o bloco some. Rodapé = peça principal (tamanho escolhido no topo) + looks incluídos. */
  var TABS = ['related', 'complementary'];
  function money(c) { return window.SV && SV.money ? SV.money(c) : (c / 100).toFixed(2).replace('.', ','); }
  function pix(c) { return window.SV && SV.pix ? SV.pix(c) : Math.round(c * 0.95); }
  function getText(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }); }
  function cardsFrom(node) { return node ? Array.prototype.slice.call(node.querySelectorAll('[data-sv-kit-card]')) : []; }

  function kitSources(root) {
    var id = root.dataset.productId, out = {};
    var ed = document.querySelector('[data-sv-kit-editorial][data-handle="' + root.dataset.handle + '"]');
    var edP = ed ? Promise.resolve(ed) : getText(root.dataset.productUrl + (root.dataset.productUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=sv-pdp-below-cross')
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html').querySelector('[data-sv-kit-editorial]'); }).catch(function () { return null; });
    return edP.then(function (edNode) {
      return Promise.all(TABS.map(function (tab) {
        var own = cardsFrom(edNode && edNode.querySelector('[data-tab="' + tab + '"]'));
        if (own.length) return own;
        var u = root.dataset.recUrl + (root.dataset.recUrl.indexOf('?') > -1 ? '&' : '?') + 'product_id=' + id + '&limit=10&intent=' + tab + '&section_id=sv-pdp-below-cross';
        return getText(u).then(function (t) { return cardsFrom(new DOMParser().parseFromString(t, 'text/html').querySelector('[data-sv-kit-list]')); }).catch(function () { return []; });
      }));
    }).then(function (lists) {
      var seen = {};
      TABS.forEach(function (tab, i) {
        out[tab] = lists[i].filter(function (c) { var k = c.dataset.productId; if (seen[k]) return false; seen[k] = 1; return true; });
      });
      return out;
    });
  }
  function pdpEl() { return document.querySelector('[data-size-chosen]'); }
  function mainLine(root) {
    var pdp = pdpEl(), scope = pdp || document;
    var idEl = scope.querySelector('form[action*="/cart/add"] [name="id"]'), qEl = scope.querySelector('input[name="quantity"]');
    var prices = {}; try { prices = JSON.parse(root.querySelector('[data-kit-variants]').textContent); } catch (e) {}
    var id = idEl && idEl.value, q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    return { id: id, quantity: q, price: prices[id] != null ? prices[id] : prices[Object.keys(prices)[0]] || 0, chosen: !pdp || pdp.getAttribute('data-size-chosen') !== 'false' };
  }
  function cardVariant(card) {
    var sel = card.querySelector('[data-kit-size]');
    var opt = sel && sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : null;
    return { id: sel ? sel.value : '', price: opt && opt.dataset.price ? +opt.dataset.price : +card.dataset.price };
  }
  function updateKit(root) {
    var m = mainLine(root), extras = root.querySelectorAll('.sv-kit__list:not([hidden]) [data-kit-include]:checked');
    var total = m.price * m.quantity;
    Array.prototype.forEach.call(extras, function (i) { total += cardVariant(i.closest('[data-sv-kit-card]')).price; });
    root.querySelector('[data-kit-total]').textContent = money(pix(total));
    var pct = (window.SV && SV.config && SV.config.pixPct) || 5, n = extras.length;
    root.querySelector('[data-kit-summary]').textContent = root.dataset.title + (n ? ' + ' + n + ' look' + (n > 1 ? 's' : '') : '') + ' · ' + pct + '% no Pix';
    root.querySelector('[data-kit-action]').textContent = n ? 'Adicionar seleção à sacola' : 'Adicionar ' + root.dataset.title;
  }
  function pickKitTab(root, tab) {
    root.querySelectorAll('[data-kit-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.kitTab === tab)); });
    root.querySelectorAll('[data-kit-pane]').forEach(function (p) { p.hidden = p.dataset.kitPane !== tab; });
    root.querySelector('[data-kit-desc]').textContent = root.dataset['desc' + tab.charAt(0).toUpperCase() + tab.slice(1)] || '';
    updateKit(root);
  }
  function initKit(root) {
    if (root.__kit) return; root.__kit = 1;
    kitSources(root).then(function (src) {
      var firstTab = null;
      TABS.forEach(function (tab) {
        var list = src[tab], pane = root.querySelector('[data-kit-pane="' + tab + '"]'), btn = root.querySelector('[data-kit-tab="' + tab + '"]');
        var max = 2; list.slice(0, max).forEach(function (c) { pane.appendChild(document.importNode(c, true)); });
        btn.hidden = !list.length;
        if (list.length && !firstTab) firstTab = tab;
      });
      if (!firstTab) { root.hidden = true; return; }
      var tabs = root.querySelectorAll('[data-kit-tab]:not([hidden])');
      root.querySelector('.sv-kit__tabs').hidden = tabs.length < 2;
      root.hidden = false;
      pickKitTab(root, firstTab);
    });
  }
  function status(root, msg) { var s = root.querySelector('[data-kit-status]'); s.textContent = msg; }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kit-tab]');
    if (t) { pickKitTab(t.closest('[data-sv-kit]'), t.dataset.kitTab); return; }
    var a = e.target.closest('[data-kit-action]');
    if (!a) return;
    var root = a.closest('[data-sv-kit]'), m = mainLine(root);
    status(root, '');
    if (!m.chosen || !m.id) { status(root, 'Escolha o tamanho de ' + root.dataset.title + '.'); document.dispatchEvent(new CustomEvent('sv:pdp:choose-size')); var tg = document.querySelector('.sv-opt--size, variant-picker'); if (tg) tg.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' }); return; }
    var items = [{ id: m.id, quantity: m.quantity }], bad = null;
    root.querySelectorAll('.sv-kit__list:not([hidden]) [data-kit-include]:checked').forEach(function (i) {
      var c = i.closest('[data-sv-kit-card]'), v = cardVariant(c);
      if (!v.id && !bad) bad = c; else if (v.id) items.push({ id: v.id, quantity: 1 });
    });
    if (bad) { var sel = bad.querySelector('[data-kit-size]'); if (sel && sel.focus) sel.focus(); status(root, 'Escolha o tamanho de ' + bad.dataset.title + '.'); return; }
    if (!window.SV || !SV.cart) return;
    a.disabled = true; a.setAttribute('aria-busy', 'true');
    SV.cart.add(items, { context: 'product', target: a }).then(function () {
      status(root, items.length > 1 ? 'Seleção adicionada à sacola.' : 'Adicionado à sacola.');
      root.querySelectorAll('[data-kit-include]:checked').forEach(function (i) { i.checked = false; });
      updateKit(root);
    }).catch(function (err) {
      var d = err && err.response && (err.response.description || err.response.message);
      status(root, d ? String(d) : 'Não foi possível adicionar agora. Tente de novo.');
    }).then(function () { a.disabled = false; a.removeAttribute('aria-busy'); });
  });
  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest('[data-sv-kit]');
    if (root) {
      if (e.target.matches('select[data-kit-size]') && e.target.value) {
        var c = e.target.closest('[data-sv-kit-card]'), inc = c.querySelector('[data-kit-include]'), v = cardVariant(c);
        if (inc) inc.checked = true;
        var px = c.querySelector('[data-kit-pix]'); if (px) px.textContent = money(pix(v.price)) + ' no Pix';
      }
      updateKit(root); return;
    }
    // troca de variante/quantidade no topo atualiza o total da Mala
    document.querySelectorAll('[data-sv-kit]:not([hidden])').forEach(updateKit);
  });
  document.addEventListener('input', function (e) { if (e.target.name === 'quantity') document.querySelectorAll('[data-sv-kit]:not([hidden])').forEach(updateKit); });

  /* título acompanha o estado: avaliações reais ("Quem veste, conta.") ou garantias ("Compra sem risco.") */
  function heading(box, k) { var h = box.querySelector('h2[data-h-rev]'); if (h && h.dataset[k]) h.textContent = h.dataset[k]; }

  /* ---- Avaliações: widget do app só aparece com avaliações reais ---- */
  function initReviews(box) {
    if (box.__rev) return; box.__rev = 1;
    var app = box.querySelector('[data-rev-app]');
    if (!app) return;
    var tries = 0;
    (function check() {
      /* Judge.me (widget novo: .jm-review-item / .jm-no-reviews-state) ou aReviews ([data-areviews-count]).
         A contagem do widget manda; o metafield reviews.rating pode estar desatualizado. */
      var count, avg, n = app.querySelector('[data-areviews-count]');
      if (n) {
        count = parseInt(n.getAttribute('data-areviews-count'), 10) || 0;
        avg = parseFloat(n.getAttribute('data-areviews-average')) || 0;
      } else if (app.querySelector('.jm-no-reviews-state, .jdgm-empty-state')) {
        count = 0; avg = 0;
      } else if (app.querySelector('.jm-review-item') && (app.querySelector('.jm-average-rating-display') || tries > 30)) {
        var t = [].map.call(app.querySelectorAll('.jm-average-rating-display .jm-text'), function (e) { return e.textContent.trim(); }).join(' ');
        var m = t.match(/(\d+[.,]\d+)\D+(\d+)/);
        avg = m ? parseFloat(m[1].replace(',', '.')) : 5; count = m ? parseInt(m[2], 10) : app.querySelectorAll('.jm-review-item').length;
      } else { if (++tries < 40) setTimeout(check, 500); return; }
      var sum = box.querySelector('[data-rev-sum]');
      if (count < 1) {
        app.hidden = true; sum.hidden = true;
        var o0 = box.querySelector('[data-rev-origin]'); if (o0) o0.hidden = true;
        box.querySelector('[data-rev-empty]').hidden = false; heading(box, 'hEmpty'); return;
      }
      var had = !sum.hidden && (sum.textContent.match(/(\d+)\s*avalia/) || [])[1];
      if (+had !== count) { /* o resumo do servidor (metafield) só é refeito se a contagem divergir */
        var full = Math.round(avg * 2), stars = '';
        for (var i = 1; i <= 5; i++) stars += (window.SV && SV.icon) ? SV.icon(full >= i * 2 ? 'star' : full === i * 2 - 1 ? 'star-half' : 'star-empty') : '';
        var sc = avg.toFixed(1).replace('.', ',');
        sum.innerHTML = '<strong>' + sc + '</strong><span class="sv-rev__stars" role="img" aria-label="' + sc + ' de 5 estrelas">' + stars + '</span><span>' + count + (count === 1 ? ' avaliação' : ' avaliações') + '</span>';
        sum.hidden = false;
      }
      var orig = box.querySelector('[data-rev-origin]'); if (orig) orig.hidden = false;
      box.querySelector('[data-rev-empty]').hidden = true; heading(box, 'hRev');
      app.classList.add('is-real'); app.hidden = false;
      moreReviews(app);
    })();
  }

  /* 5 avaliações + "Ver mais" (Everton, 15/10/2026). O tipo de paginação do Judge.me é do plano pago:
     aqui a paginação nativa some, e cada "Ver mais" guarda as atuais e pede a próxima página ao widget,
     então a lista cresce para baixo. Filtro/ordenação do widget recomeçam a lista. */
  function moreReviews(app, tries) {
    if (app.__more) return;
    var nav = app.querySelector('.jm-pagination-controls');
    if (!nav) { if ((tries || 0) < 20) setTimeout(function () { moreReviews(app, (tries || 0) + 1); }, 300); return; }
    app.__more = 1; app.classList.add('has-more');
    var held = document.createElement('div'); held.className = 'sv-rev__held';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sv-rev__more'; btn.textContent = 'Ver mais avaliações';
    app.after(btn);
    function list() { return app.querySelector('.jdgm-review-list'); }
    function next() { return app.querySelector('[aria-label="Go to next page"]'); }
    function sync() { var n = next(); btn.hidden = !n || n.disabled; }
    sync();
    app.addEventListener('click', function (e) {
      if (e.isTrusted && !e.target.closest('.jm-review-item') && held.childNodes.length) { held.textContent = ''; setTimeout(sync, 800); }
    });
    btn.addEventListener('click', function () {
      var l = list(), n = next(); if (!l || !n || n.disabled) { btn.hidden = true; return; }
      var first = l.firstElementChild && l.firstElementChild.textContent;
      [].forEach.call(l.children, function (c) { held.appendChild(c.cloneNode(true)); });
      if (!held.isConnected) l.before(held);
      var sc = (window.SV && SV.scroller && SV.scroller()) || document.scrollingElement, y = sc.scrollTop, t = 0;
      btn.disabled = true; btn.textContent = 'Carregando…';
      n.click();
      (function wait() {
        var l2 = list();
        if ((l2 && l2.firstElementChild && l2.firstElementChild.textContent !== first) || ++t > 40) {
          sc.scrollTop = y; requestAnimationFrame(function () { sc.scrollTop = y; });
          btn.disabled = false; btn.textContent = 'Ver mais avaliações'; sync(); return;
        }
        setTimeout(wait, 100);
      })();
    });
  }

  function scan() {
    document.querySelectorAll('[data-sv-kit]').forEach(function (r) {
      if (r.__kitSeen) return; r.__kitSeen = 1;
      if (!('IntersectionObserver' in window)) return initKit(r);
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); initKit(r); } }, { rootMargin: '0px 0px 600px 0px' });
      // a seção começa oculta (hidden): observa a seção pai, que ocupa lugar no fluxo
      io.observe(r.parentNode);
    });
    document.querySelectorAll('[data-sv-reviews]').forEach(initReviews);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
